module.exports = __webpack_public_path__ + "media/images/favicon-0966098837f5da3f2ab62e95c7ba3dc0.ico";